// import React from "react";
// import womanImg from "../../assets/images/MENS.webp";
// import menImg from "../../assets/images/WOMENS.webp";
// import shoesImg from "../../assets/images/Shoes.jpeg";
// import accessoriesImg from "../../assets/images/accessories.webp";
// import { Package, RefreshCw, Headphones, CreditCard } from "lucide-react";
// import { Link } from "react-router-dom"; // ✅ Add this

// const FeatureSection = () => {
//   return (
//     <section className="max-w-7xl mx-auto py-12 px-4">
//       {/* Grid Section */}
//       <div className="grid grid-cols-1 lg:grid-cols-10 gap-6 min-h-[600px]">
//         <div className="col-span-1 lg:col-span-5 relative bg-gray-100 overflow-hidden">
//           <img
//             src={womanImg}
//             alt="Men"
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute inset-0 flex items-start px-4 sm:px-6 pt-6 sm:pt-20 text-black">
//             <div>
//               <h2 className="text-xl sm:text-2xl font-semibold mb-3">Men</h2>
//               <ul className="mt-2 space-y-1 text-sm">
//                 {[
//                   "Polos",
//                   "Shorts",
//                   "Shooting",
//                   "Tracksuits",
//                   "Pants & Leggings",
//                   "Football",
//                   "Supporters",
//                   "Cricket",
//                   "Training",
//                 ].map((item) => (
//                   <li key={item} className="hover:underline cursor-pointer">
//                     {item}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//         <div className="col-span-1 lg:col-span-5 flex flex-col gap-6">
//           {/* Men */}
//           <div className="relative bg-gray-100 overflow-hidden h-full">
//             <Link
//               to=""
//               className="relative bg-gray-100 overflow-hidden h-full block"
//             >
//               <img
//                 src={menImg}
//                 alt="Men"
//                 className="w-full h-full object-cover"
//               />
//               <div className="absolute top-8 left-6 text-black ">
//                 {/* <p className="text-sm">23 products</p> */}
//                 <h2 className="text-2xl font-semibold">Women</h2>
//                 <ul className="mt-2 space-y-1 text-sm">
//                   {[
//                     "Shorts & Skirts",
//                     "Long Sleeves",
//                     "Indian Merchandise",
//                     "Tops",
//                   ].map((item) => (
//                     <li key={item} className="hover:underline cursor-pointer">
//                       {item}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </Link>
//           </div>

//           {/* Shoes and Accessories */}
//           <div className="grid grid-cols-2 gap-6">
//             <div className="relative bg-gray-100 overflow-hidden">
//               <img
//                 src={shoesImg}
//                 alt="Shoes"
//                 className="w-full h-full object-cover"
//               />
//               <div className="absolute top-2 left-4 sm:top-8 sm:left-6 text-black">
//                 {/* <p className="text-sm">1 product</p> */}
//                 <h2 className="text-lg font-semibold">Shoes</h2>
//               </div>
//             </div>
//             <div className="relative bg-gray-100 overflow-hidden">
//               <img
//                 src={accessoriesImg}
//                 alt="Accessories"
//                 className="w-full h-full object-cover"
//               />
//               <div className="absolute top-2 left-4 sm:top-8 sm:left-6 text-black">
//                 <h2 className="text-lg font-semibold">Accessories</h2>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeatureSection;

// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";

// const FeatureSection = () => {
//   const [banners, setBanners] = useState([]);

//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         const res = await fetch(
//           "https://tyka.premierhostings.com/backend/api/site-banner"
//         );
//         const data = await res.json();
//         if (data?.top_banner?.data) {
//           setBanners(data.top_banner.data);
//         }
//       } catch (error) {
//         console.error("Error fetching banners:", error);
//       }
//     };
//     fetchBanners();
//   }, []);

//   return (
//     <section className="max-w-7xl mx-auto py-12 px-4">
//       {/* Grid Section */}
//       <div className="grid grid-cols-1 lg:grid-cols-10 gap-6 min-h-[600px]">
//         {/* Left Side Banner */}
//         {banners[0] && (
//           <div className="col-span-1 lg:col-span-5 relative bg-gray-100 overflow-hidden">
//             <a
//               href={banners[0].target_url}
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img
//                 src={`https://tyka.premierhostings.com/backend/storage/${banners[0].banner_image}`}
//                 alt="Top Banner 1"
//                 className="w-full h-full object-cover"
//               />
//             </a>
//           </div>
//         )}

//         {/* Right Side Banners */}
//         <div className="col-span-1 lg:col-span-5 flex flex-col gap-6">
//           {/* Women Section */}
//           {banners[1] && (
//             <div className="relative bg-gray-100 overflow-hidden h-full">
//               <Link
//                 to={banners[1].target_url}
//                 className="relative bg-gray-100 overflow-hidden h-full block"
//               >
//                 <img
//                   src={`https://tyka.premierhostings.com/backend/storage/${banners[1].banner_image}`}
//                   alt="Top Banner 2"
//                   className="w-full h-full object-cover"
//                 />
//               </Link>
//             </div>
//           )}

//           {/* Shoes and Accessories Section */}
//           <div className="grid grid-cols-2 gap-6">
//             {banners[2] && (
//               <div className="relative bg-gray-100 overflow-hidden">
//                 <a
//                   href={banners[2].target_url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <img
//                     src={`https://tyka.premierhostings.com/backend/storage/${banners[2].banner_image}`}
//                     alt="Top Banner 3"
//                     className="w-full h-full object-cover"
//                   />
//                 </a>
//               </div>
//             )}
//             {banners[3] && (
//               <div className="relative bg-gray-100 overflow-hidden">
//                 <a
//                   href={banners[3].target_url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <img
//                     src={`https://tyka.premierhostings.com/backend/storage/${banners[3].banner_image}`}
//                     alt="Top Banner 4"
//                     className="w-full h-full object-cover"
//                   />
//                 </a>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeatureSection;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const FeatureSection = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await fetch(
          "https://tyka.premierhostings.com/backend/api/site-banner"
        );
        const data = await res.json();
        if (data?.top_banner?.data) {
          setBanners(data.top_banner.data);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };
    fetchBanners();
  }, []);

  // agar top_banner empty hai to section mat dikhana
  if (!banners || banners.length === 0) {
    return null;
  }

  // background images assign (agar kam banners aaye to fallback empty string)
  const men = banners[0] || {};
  const women = banners[1] || {};
  const shoes = banners[2] || {};
  const accessories = banners[3] || {};

  const imgUrl = (banner) =>
    banner?.banner_image
      ? `https://tyka.premierhostings.com/backend/storage/${banner.banner_image}`
      : "";

  // clickable wrapper helper
  const ClickableImage = ({ banner, alt, children }) => {
    const src = imgUrl(banner);
    if (!src) return null;

    if (banner?.target_url) {
      // agar target_url external hai
      if (banner.target_url.startsWith("http")) {
        return (
          <a href={banner.target_url} target="_blank" rel="noopener noreferrer">
            <img src={src} alt={alt} className="w-full h-full object-cover" />
            {children}
          </a>
        );
      }
      // internal route
      return (
        <Link to={banner.target_url}>
          <img src={src} alt={alt} className="w-full h-full object-cover" />
          {children}
        </Link>
      );
    }

    // agar target_url nahi hai
    return (
      <>
        <img src={src} alt={alt} className="w-full h-full object-cover" />
        {children}
      </>
    );
  };

  return (
    <section className="max-w-7xl mx-auto py-12 px-4">
      {/* Grid Section */}
      <div className="grid grid-cols-1 lg:grid-cols-10 gap-6 min-h-[600px]">
        {/* Men */}
        <div className="col-span-1 lg:col-span-5 relative bg-gray-100 overflow-hidden">
          <ClickableImage banner={men} alt="Men">
            <div className="absolute inset-0 flex items-start px-4 sm:px-6 pt-6 sm:pt-20 text-black">
              <div>
                <h2 className="text-xl sm:text-2xl font-semibold lg:mt-[-50px]">
                  Men
                </h2>
                {/* <ul className="mt-2 space-y-1 text-sm">
                  {[
                    { name: "Polos", path: "/MEN/polos" },
                    { name: "Shorts", path: "/MEN/shorts" },
                    { name: "Shooting", path: "/MEN/shooting" },
                    { name: "Tracksuits", path: "/MEN/tracksuits" },
                    {
                      name: "Pants & Leggings",
                      path: "/MEN/pants-and-leggings",
                    },
                    { name: "Football", path: "/MEN/football" },
                    { name: "Supporters", path: "/post/supporters-1" },
                    { name: "Cricket", path: "/MEN/cricket" },
                    { name: "Training", path: "/MEN/training" },
                  ].map((item) => (
                    <li
                      key={item.name}
                      className="hover:underline cursor-pointer"
                    >
                      <Link to={item.path}>{item.name}</Link>
                    </li>
                  ))}
                </ul> */}
              </div>
            </div>
          </ClickableImage>
        </div>

        {/* Right side */}
        <div className="col-span-1 lg:col-span-5 flex flex-col gap-6">
          {/* Women */}
          <div className="relative bg-gray-100 overflow-hidden h-full">
            <ClickableImage banner={women} alt="Women">
              <div className="absolute top-8 left-6 text-black">
                <h2 className="text-2xl font-semibold">Women</h2>
                {/* <ul className="mt-2 space-y-1 text-sm">
                  {[
                    {
                      name: "Shorts & Skirts",
                      path: "/WOMEN/shorts-and-skirts",
                    },
                    { name: "Long Sleeves", path: "/WOMEN/long-sleeves" },
                    {
                      name: "Indian Merchandise",
                      path: "/WOMEN/india-merchandise-1",
                    },
                    { name: "Tops", path: "/WOMEN/tops-1" },
                  ].map((item) => (
                    <li
                      key={item.name}
                      className="hover:underline cursor-pointer"
                    >
                      <Link to={item.path}>{item.name}</Link>
                    </li>
                  ))}
                </ul> */}
              </div>
            </ClickableImage>
          </div>

          {/* Shoes and Accessories */}
          <div className="grid grid-cols-2 gap-6">
            <div className="relative bg-gray-100 overflow-hidden">
              <ClickableImage banner={shoes} alt="Shoes">
                <div className="absolute top-2 left-4 sm:top-8 sm:left-6 text-black">
                  <h2 className="text-lg font-semibold">Shoes</h2>
                </div>
              </ClickableImage>
            </div>
            <div className="relative bg-gray-100 overflow-hidden">
              <ClickableImage banner={accessories} alt="Accessories">
                <div className="absolute top-2 left-4 sm:top-8 sm:left-6 text-black">
                  <h2 className="text-lg font-semibold">Accessories</h2>
                </div>
              </ClickableImage>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
